import React, { FC } from 'react';
import InitializingSpinner from 'app/modules/insights/components/initializingStatus/InitializingSpinner';
import InitializingMessage from './initializingStatus/InitializingMessage';
import { useTranslation } from 'react-i18next';

type Props = {
  status: 'loading' | 'error';
  message?: {
    main?: string;
    secondary?: string;
  };
};

const InitializationStatus: FC<Props> = ({ message, status }) => {
  const { t } = useTranslation();
  return (
    <div className="tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center">
      <div>
        {status === 'loading' && <InitializingSpinner />}
        {(message || status === 'error') && (
          <InitializingMessage
            message={message?.main ?? t('insights.initializing.errorMain')}
            secondaryMessage={
              message?.secondary ?? t('insights.initializing.errorSecondary')
            }
          />
        )}
      </div>
    </div>
  );
};
export default InitializationStatus;
